module.exports = __webpack_public_path__ + "io_bw.svg?f7f038d6f69d8ed6d35727b28e52c371";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/io_bw.svg
// module id = 16
// module chunks = 0